module.exports = __webpack_public_path__ + "static/hero_visual_front-098d4ab554823caef276aa859b688979.png";